import React from 'react';
import OriginalOrderItems from './OriginalOrderItems';
import PartiallyCanceledItems from './PartiallyCanceledItems';
import CancelledItems from './CancelledItems';
import {
  TRANSITION_CANCEL_BY_OPERATOR,
  TRANSITION_CANCEL_BY_OPERATOR_AFTER_PICKUP,
  TRANSITION_CANCEL_BY_PROVIDER,
  TRANSITION_CONFIRM_PAYMENT,
  TRANSITION_CONFIRM_PAYMENT_INSTANT_BOOKING,
  TRANSITION_CONFIRM_PAYMENT_INSTANT_BOOKING_BY_OPERATOR,
} from '../../../util/transaction';

const PARTIAL_CANCEL_TRANSITION = 'partial-cancel';
const CANCEL_TRANSITION = 'cancel';
const CONFIRM_PAYMENT = 'confirm-payment';

const confirmPaymentStatus = [
  TRANSITION_CONFIRM_PAYMENT,
  CONFIRM_PAYMENT,
  TRANSITION_CONFIRM_PAYMENT_INSTANT_BOOKING,
  TRANSITION_CONFIRM_PAYMENT_INSTANT_BOOKING_BY_OPERATOR,
];

const cancelStatus = [
  CANCEL_TRANSITION,
  TRANSITION_CANCEL_BY_OPERATOR,
  TRANSITION_CANCEL_BY_OPERATOR_AFTER_PICKUP,
  TRANSITION_CANCEL_BY_PROVIDER,
];

const ItemSummary = ({ transitions, intl, listings, lineItems }) => {
    return transitions.map(({ transition, relLineItemIndex, relLineItemsAmount }, index) => {

      if (confirmPaymentStatus.includes(transition)) {
        const confirmList = lineItems.slice(
          relLineItemIndex,
          relLineItemIndex + relLineItemsAmount
        );

        return (
          <OriginalOrderItems
            confirmLineItems={confirmList}
            intl={intl}
            listings={listings}
          />
        )
      }

      if (transition === PARTIAL_CANCEL_TRANSITION) {
        const partialCancelLineItems = lineItems.slice(
          relLineItemIndex,
          relLineItemIndex + relLineItemsAmount
        );

        return (
          <PartiallyCanceledItems
            partialCancelLineItems={partialCancelLineItems}
            relLineItemIndex={relLineItemIndex}
            intl={intl}
            listings={listings}
          />
        )
      }

      if (cancelStatus.includes(transition)) {
        const cancelList = lineItems.slice(relLineItemIndex, relLineItemIndex + relLineItemsAmount);

        return (
          <CancelledItems
            cancelList={cancelList}
            intl={intl}
            listings={listings}
          />
        )
      }

      return null;
    });
}

export default ItemSummary;
